import packageCrud from "./services/PackageCRUD.api";
import moment from "moment";

export function hasChildren(item) {
  const { items: children } = item;
  if (children === undefined) {
    return false;
  }
  if (children.constructor !== Array) {
    return false;
  }
  if (children.length === 0) {
    return false;
  }
  return true;
}

export function getCookieValue(name) {
  let cookie = {};
  document.cookie.split(";").forEach(function (el) {
    let split = el.split("=");
    cookie[split[0].trim()] = split.slice(1).join("=");
  });
  return cookie[name];
}

export function getStorageValue(key) {
  return localStorage.getItem(key);
};

export function isBase64(str) {
  // Check if the string matches the Base64 encoding pattern
  const base64Pattern = /^[A-Za-z0-9+/=]+$/;
  return base64Pattern.test(str) && str.length % 4 === 0;
}

export function getEncryptedPassword(key) {
  let decodedValue;
  if(localStorage.getItem(key) && isBase64(localStorage.getItem(key))) {
    decodedValue = window.atob(localStorage.getItem(key));
  } else {
    decodedValue = localStorage.getItem(key);
  }
  return decodedValue;
};

export function getEncryptedStorageValue(key) {
  let decodedValue;
  if(localStorage.getItem(key)) {
    decodedValue = window.atob(localStorage.getItem(key));
  } else {
    decodedValue = localStorage.getItem(key);
  }
  return decodedValue;
};

export function setStorageValue(key, value) {
  localStorage.setItem(key, value);
};

export function setEncryptedStorageValue(key, value) {
  if(value) {
    const encodedValue = window.btoa(value);
    localStorage.setItem(key, encodedValue);
  } else {
    localStorage.setItem(key, value);
  }
  
};

export const deleteStorageValue = (key) => {
  localStorage.removeItem(key);
};

export const deleteAllStorageValue = (...keys) => {
  for(let i=0; i<keys.length; i++) {
    localStorage.removeItem(keys[i]);
  }
};

export function getExpiryTime() {
  let expireTime = new Date();
  expireTime.setHours(expireTime.getHours() + 3);
  return expireTime;
}

export function packageRequestAdapter(packageDetails, mode, id) {
  const expiryDateConverted = moment(new Date(packageDetails.expiryDate))?.format('YYYY-MM-DD');
  return {
    ...(mode === "edit" ? { id: id } : {}),
    title: packageDetails.packageName,
    description: packageDetails.description,
    size: {
      height: parseFloat(packageDetails.height),
      width: parseFloat(packageDetails.width),
      depth: parseFloat(packageDetails.depth),
    },
    weight: parseFloat(packageDetails.weight),
    expiresAt: packageDetails.expiryDate
    ? new Date(expiryDateConverted)?.toISOString()
      : null,
    [mode === "create" ? "requestedBy" : "updatedBy"]: getStorageValue("userId"),
    specialInstruction: packageDetails.specialInstructions || "",
    source: {
      contactName: packageDetails.pickupFullName || "",
      countryCode: "+1",
      contactNumber: packageDetails.pickupPhoneNumber?.toString() || "",
      addressLine: packageDetails.pickupAddress || "",
      city: packageDetails.pickupCity || "",
      state: packageDetails.pickupState || "",
      zipCode: packageDetails.pickupZipcode || "",
      longitude: packageDetails.pickupLongitude || "",
      latitude: packageDetails.pickupLatitude || "",
      isMyAddressChecked: packageDetails?.autofillPickupAddress || false,
    },
    destination: {
      contactName: packageDetails.deliveryFullName || "",
      countryCode: "+1",
      contactNumber: packageDetails.deliveryPhoneNumber?.toString() || "",
      addressLine: packageDetails.deliveryAddress || "",
      city: packageDetails.deliveryCity || "",
      state: packageDetails.deliveryState || "",
      zipCode: packageDetails.deliveryZipcode || "",
      longitude: packageDetails.deliveryLongitude,
      latitude: packageDetails.deliveryLatitude,
      isMyAddressChecked: packageDetails?.autofillDeliveryAddress || false,
    },
  };
}

export function fetchPackageDetailsAdapter(response) {
  return {
    packageName: response.title || "",
    description: response.description || "",
    height: response.size?.height?.toString() || "",
    width: response.size?.width?.toString() || "",
    depth: response.size?.depth?.toString() || "",
    weight: response.weight?.toString() || "",
    expiryDate: response.expiresAt
      ? response.expiresAt?.split("T")[0]
      : "",
    specialInstructions: response.specialInstruction || "",
    pickupFullName: response.source?.contactName || "",
    pickupPhoneNumber: response.source?.contactNumber || "",
    pickupAddress: response.source?.addressLine || "",
    pickupCity: response.source?.city || "",
    pickupState: response.source?.state || "",
    pickupZipcode: response.source?.zipCode || "",
    pickupLatitude: response.source?.latitude || "",
    pickupLongitude: response.source?.longitude || "",
    deliveryFullName: response.destination?.contactName || "",
    deliveryPhoneNumber: response.destination?.contactNumber || "",
    deliveryAddress: response.destination?.addressLine || "",
    deliveryCity: response.destination?.city || "",
    deliveryState: response.destination?.state || "",
    deliveryZipcode: response.destination?.zipCode || "",
    deliveryLatitude: response.destination?.latitude || "",
    deliveryLongitude: response.destination?.longitude || "",
    autofillPickupAddress: response.source?.isMyAddressChecked || false,
    autofillDeliveryAddress: response.destination?.isMyAddressChecked || false,
  };
}

export function emailIDMasking(emailID) {
  let endString = emailID.substring(emailID.indexOf("@"), emailID.length);
  let startString = emailID.substring(0, emailID.indexOf("@"));
  return startString.length > 2
    ? startString.substring(0, 2) +
        Array(startString.length - 1).join("*") +
        startString.substring(startString.length - 2, startString.length) +
        endString
    : startString + endString;
}

export const getDropdownState = async () => {
  const response = await packageCrud.getDropdownState();
  if (response.status === "success") {
    return { status: "success", data: response.data };
  }
  return { status: "error", message: "Failed to fetch states" };
};

export const getDropdownCity = async (state) => {
  if (!state) return { status: "error", message: "State is missing" };

  const response = await packageCrud.getDropdownCity(state);
  if (response.status === "success") {
    return { status: "success", data: response.data };
  }
  return { status: "error", message: "Failed to fetch cities" };
};

export const getDropdownZipCode = async (state, city) => {
  if (!state || !city)
    return { status: "error", message: "State or city is missing" };

  const response = await packageCrud.getDropdownZipCode(state, city);
  if (response.status === "success") {
    return { status: "success", data: response.data };
  }
  return { status: "error", message: "Failed to fetch zip codes" };
};

export const convertUTCToMTSTimeZone = (val) => {
  const expirydate = moment(new Date(val))?.format('YYYY-MM-DD')
  const date = new Date(expirydate);
  return (
    date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
  );
};

export const validateDate = (val) => {
  const date = new Date(val);
  return (
    date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
  );
};

export const deleteCookie = () => {
  document.cookie.split(";").forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = name + "=; Max-Age=0";
  });
};

export const truncateTitle = (title, length = 50) => {
  if (!title) return "";
  return title.length > length ? `${title.slice(0, length)}...` : title;
};

export const loginVariableSetting = (data) => {
  setStorageValue("lastName", data?.lastName);
  setStorageValue("userInfo", JSON.stringify(data));
  setEncryptedStorageValue("accessToken", data?.accessToken);
  setEncryptedStorageValue("refreshToken", data?.refreshToken);
  setStorageValue("userEmail", data?.email);
  setStorageValue("roleId", data?.roleId);
  setStorageValue("userId", data?.id);
  setStorageValue("firstName", data?.firstName);
  setStorageValue("menuName", "Admin");
  setStorageValue("openMenu", "yes");
  setStorageValue("SearchParams", "");
  setStorageValue("FilterParams", "");
  setStorageValue("PageSize", "");
  setStorageValue("SortByParams", "");
  setStorageValue("RequestTabs", "");
  setStorageValue("DeliveryTabs", "");
}

export const formatPhoneNumber = (value) => {
  const cleaned = value?.replace(/\D/g, "");

  const match = cleaned?.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return cleaned;
};

export const dimensionsCalculation = (packageDetails) => {
  if (
    packageDetails?.size?.height ||
    packageDetails?.size?.width ||
    packageDetails?.size?.depth
  ) {
    return (
      (packageDetails?.size.height
        ? packageDetails?.size.height.toFixed(2) + " H"
        : "-") +
      " x " +
      (packageDetails?.size.width
        ? packageDetails?.size.width.toFixed(2) + " W"
        : "-") +
      " x " +
      (packageDetails?.size.depth
        ? packageDetails?.size.depth.toFixed(2) + " D"
        : "-")
    );
  } else {
    return "-";
  }
};

export const formatDate = (timestamp) => {
  if (!timestamp) {
    return "Invalid date";
  }

  const date = new Date(timestamp);
  const year = date.getFullYear();
  const monthName = date.toLocaleString("default", { month: "long" });
  const day = String(date.getDate()).padStart(2, "0");

  return ` ${day} ${monthName} ${year}`;
};

export const compareDate = (timestamp) => {
  if (!timestamp) {
    return "Invalid date";
  }
  const date = new Date(timestamp);
  const currentDate = new Date();
  return date.getTime() < currentDate.getTime();
};

const copyLink = process.env.REACT_APP_BASE_URL;

const toBold = (text) => {
    const boldMap = {
      a: "𝐚",
      b: "𝐛",
      c: "𝐜",
      d: "𝐝",
      e: "𝐞",
      f: "𝐟",
      g: "𝐠",
      h: "𝐡",
      i: "𝐢",
      j: "𝐣",
      k: "𝐤",
      l: "𝐥",
      m: "𝐦",
      n: "𝐧",
      o: "𝐨",
      p: "𝐩",
      q: "𝐪",
      r: "𝐫",
      s: "𝐬",
      t: "𝐭",
      u: "𝐮",
      v: "𝐯",
      w: "𝐰",
      x: "𝐱",
      y: "𝐲",
      z: "𝐳",
      A: "𝐀",
      B: "𝐁",
      C: "𝐂",
      D: "𝐃",
      E: "𝐄",
      F: "𝐅",
      G: "𝐆",
      H: "𝐇",
      I: "𝐈",
      J: "𝐉",
      K: "𝐊",
      L: "𝐋",
      M: "𝐌",
      N: "𝐍",
      O: "𝐎",
      P: "𝐏",
      Q: "𝐐",
      R: "𝐑",
      S: "𝐒",
      T: "𝐓",
      U: "𝐔",
      V: "𝐕",
      W: "𝐖",
      X: "𝐗",
      Y: "𝐘",
      Z: "𝐙",
    };
    return text
      .split("")
      .map((char) => boldMap[char] || char)
      .join("");
  };

export const copyPackageDetails = (packageDetails, handleSnackbarOpen) => {
    if (packageDetails) {
      const userLoggedIn = !!parseInt(getStorageValue("userId"));
      const loginURL = copyLink;
      const packageURL = `${copyLink}view/${packageDetails?.packageCode}`;

      const boldTitle = toBold(
        "🚚 A2B Deliver Delivery Request: Package Ready for Pickup 🚚"
      );

      const detailsToCopy = `
  ${boldTitle}
  
  We have a package ready that needs a reliable person to transport it to its destination. Here are the key details:
  
  📦Package Name: ${packageDetails.title || "-"}
  📏Dimensions: ${packageDetails.size.height || "-"} in (H) x ${
        packageDetails.size.width || "-"
      } in (W) x ${packageDetails.size.depth || "-"} in (D)
  ⚖️Weight: ${packageDetails.weight || "-"} lbs
  📍Pickup Location: ${packageDetails.source.city || "-"}, ${
        packageDetails.source.state || "-"
      }, ${packageDetails.source.zipCode || "-"}
  📍Delivery Location: ${packageDetails.destination.city || "-"}, ${
        packageDetails.destination.state || "-"
      }, ${packageDetails.destination.zipCode || "-"}
  
  For pickup and delivery locations and contact details, please ${
    userLoggedIn
      ? `click the link below: ${packageURL}`
      : `log in to access the link: ${loginURL}`
  }
  
  We invite you to accept this job and help the package owner to get his delivery. Thank you for your continued support of our delivery network!
  
  Don't have the app yet? Please download it here:
  https://play.google.com/store/apps/details?id=com.a2bdeliver.app | https://apps.apple.com/in/app/a2b-deliver/id6745030274
  `.trim();

      navigator.clipboard.writeText(detailsToCopy).then(
        () => {
          handleSnackbarOpen();
        },
        (err) => {
          console.error("Failed to copy details:", err);
        }
      );
    }
  };